import React, { Component } from "react";
import PropTypes from "prop-types";
import { Spinner } from "../../components";

class Login extends Component {
  componentDidMount() {
    this.props.auth.login();
  }

  render() {
    return <Spinner message="Checking login" />;
  }
}

Login.proptypes = {
  auth: PropTypes.object.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/views/login/Login.jsx